<div class="usan-form-item instructions-container">
  <div class="instructions-text">
    Checklist of Required information. The following items must be supplied with the USAN application form when the firm
    files a request for a USAN.
  </div>
</div>